import { ReferenceType } from '../../common/enums/ReferenceType';
import { countBy, pipe, map, filter } from 'ramda';
import { IReferenceCandidateForm } from '../../common/models/reference/IReferenceCandidateForm';
import { IRefReqCounters } from '../../common/models/referenceRequest/IRefReqCounters';
import { IFormattedMessage } from '../../common/models/common/IFormattedMessage';

export const refTypes = [
  ReferenceType.Manager,
  ReferenceType.Peer,
  ReferenceType.Subordinate,
  ReferenceType.Educator,
  ReferenceType.Other
];

export const messages: Record<ReferenceType, IFormattedMessage> = {
  [ReferenceType.Manager]: { id: 'candidateForm.myManager', defaultMessage: 'My manager' },
  [ReferenceType.Peer]: { id: 'candidateForm.myPeer', defaultMessage: 'My peer/colleague' },
  [ReferenceType.Subordinate]: { id: 'candidateForm.mySubordinate', defaultMessage: 'My subordinate' },
  [ReferenceType.Educator]: { id: 'candidateForm.myEducator', defaultMessage: 'My educator' },
  [ReferenceType.Other]: { id: 'candidateForm.myOther', defaultMessage: 'Other' }
};

export const getTotalByType = (type: ReferenceType, counters: IRefReqCounters) => {
  switch (type) {
    case ReferenceType.Manager: return counters.managersCount;
    case ReferenceType.Other: return counters.othersCount;
    case ReferenceType.Peer: return counters.peersCount;
    case ReferenceType.Subordinate: return counters.subordinatesCount;
    case ReferenceType.Educator: return counters.educatorsCount;
    default: return 0;
  }
};

export const getCountByType = (
  references: IReferenceCandidateForm[],
  type: ReferenceType
) => countBy(ref => ref.type || '', references)[type] || 0;

export const getReferenceProgress = (references: IReferenceCandidateForm[], counters: IRefReqCounters) => pipe(
  map((type: ReferenceType) => ({
    type,
    provided: getCountByType(references, type),
    total: getTotalByType(type, counters)
  })),
  filter<{ type: ReferenceType; provided: number; total: number }, 'array'>(
    ({ provided, total }) => Boolean(provided) || Boolean(total)
  )
)(refTypes);
